module.exports = __webpack_public_path__ + "media/images/brands/logo_energie_schweiz_fr-eef0e57cedb081d0e67c56ef806d1e3b.svg";